import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet, Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import { DownloadAxiosFile } from 'utils'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Reportes' },
  { name: 'Registro Compras' }
]

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoRegistroCompras = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || '',
      flagDescargarValidacion: false
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      __zariContext.loader.open('Descargando registro de compras ...')
      await AsientoContableService.descargarRegistroCompras(formData)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Registro Compras' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        {__adminContext.mesTrabajo && (
          <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting, handleSubmit, values }) => (
              <Form>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col md={6}>
                        <FormGroups.MesContabilidadFormGroup iError={errors.mes} iTouched={touched.mes} fIsSubmitting={isSubmitting} />
                        <FormGroups.FlagDescargarValidacionFormGroup fIsSubmitting={isSubmitting} iValue={values.flagDescargarValidacion} />
                      </Col>
                      <Col md={2}>
                        <Button className='mb-3' disabled={isSubmitting} onClick={handleSubmit}>
                          {isSubmitting ? 'Descargando reporte ...' : 'Descargar'}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoRegistroCompras)
